module.exports = __webpack_public_path__ + "static/media/ic-quote-empty.c9cb1381.svg";